import user from './auth'

export default {
  guest(to, from, next) {
    next(true)
  },
  auth(to, from, next) {
    if (!user.isLogin()) user.cleanUserData()

    next(
      user.isLogin()
        ? true
        : {
            path: '/signin',
            query: {
              redirect: to.name,
            },
          }
    )
  },
}



// WEBPACK FOOTER //
// ./src/services/middleware.js